import store from '../transfer/stores/configureStore'
import { triggerExternalHook } from '../transfer/actions/Actions'
import _ from 'lodash'

const ONE_TOUCH_AUTH_STATE = 'REMEMBERED'
const LOGGEDIN_AUTH_STATE = 'LOGGEDIN'

export function isOneTouchEnabled() {
  const { external } = store.getState()
  return external.oneTouchEnabled
}

export function isUserLoggedIn() {
  return _.get(store.getState(), 'server.userAuthState') === LOGGEDIN_AUTH_STATE
}

export function isOneTouchUser() {
  return (
    _.get(store.getState(), 'server.userAuthState') === ONE_TOUCH_AUTH_STATE
  )
}

export function requestLoginAction() {
  const { server } = store.getState()

  // `donate` will redirect the user to UL
  if (server.env === 'donate') {
    return triggerExternalHook('requestUnifiedLogin')
  }
}
